import { useContext, useMemo } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { FaArrowRotateRight } from 'react-icons/fa6'

import useServer from '../../../api/useServerMain'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import TextArea from '../../../components/forms/TextArea'
import Button from '../../../components/misc/Button'
import { SelectInterface } from '../../../interfaces/InterfacesLocal'
import { useAppSelector } from '../../../store/hooks'
import { DetailProductContext } from '../DetailProductContainer'

const Labels = () => {
  const { denyRoles } = useServer()
  const { product, updateProduct } = useContext(DetailProductContext)
  const { business } = useAppSelector((state) => state.init)
  const finderAreas = useAppSelector((state) => state.nomenclator.finderAreas)
  const { handleSubmit, control } = useForm()

  const onSubmit: SubmitHandler<Record<string, unknown>> = (data) => {
    const {
      printableLabelFront,
      printableLabelBack,
      expirationInDaysAfterProduction,
      productionOriginAreaId,
    } = data

    const dataToSend = {
      printableLabelFront,
      printableLabelBack,
      expirationInDaysAfterProduction,
      productionOriginAreaId,
    }

    updateProduct?.(product?.id, dataToSend)
  }

  const processAreaSelector: SelectInterface[] = useMemo(
    () =>
      finderAreas
        .filter((item) => item.type === 'MANUFACTURER')
        .map((item) => ({
          id: item.id,
          name:
            business?.id === item?.business?.id
              ? item.name
              : `${item.name} - ${item?.business?.name}`,
        })),
    [finderAreas, business?.id]
  )

  return (
    <form
      className="grid grid-cols-1 place-content-between"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="flex h-auto flex-col items-start justify-start gap-2 rounded-md border border-slate-300 p-7">
        <div className="w-full">
          <TextArea
            control={control}
            defaultValue={product?.printableLabelFront}
            label="Etiqueta andverso"
            name="printableLabelFront"
          />
        </div>
        <div className="w-full">
          <TextArea
            control={control}
            defaultValue={product?.printableLabelBack}
            label="Etiqueta reverso"
            name="printableLabelBack"
          />
        </div>

        <div className="w-full">
          <Input
            control={control}
            defaultValue={product?.expirationInDaysAfterProduction}
            label="Al producir, extender su expiración en (días)"
            name="expirationInDaysAfterProduction"
            placeholder="Ejemplo: 7"
            type="number"
          />
        </div>
        <div className="mt-3 w-full">
          <Select
            control={control}
            data={processAreaSelector}
            defaultValue={product?.productionOriginAreaId}
            label="Área de elaboración de origen"
            name="productionOriginAreaId"
          />
        </div>
      </div>

      <div className="flex justify-end py-4">
        {denyRoles(['AUDITOR']) && (
          <Button
            color="slate-600"
            icon={<FaArrowRotateRight className={`h-5`} />}
            name="Actualizar"
            type="submit"
          />
        )}
      </div>
    </form>
  )
}

export default Labels
